import useAppStore from '../store/appStore'

export default function Topbar({ title, subtitle, actions }) {
  const { condominioAtivo } = useAppStore()

  return (
    <header style={{
      height: 'var(--header-h)', background: 'var(--surface)',
      borderBottom: '1px solid var(--border)',
      display: 'flex', alignItems: 'center', padding: '0 24px', gap: 12
    }}>
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 600, fontSize: 15 }}>{title}</div>
        <div style={{ fontSize: 12, color: 'var(--text-secondary)' }}>
          {subtitle || (condominioAtivo ? `${condominioAtivo.nome} · ${new Date().toLocaleDateString('pt-PT', { month: 'long', year: 'numeric' })}` : '')}
        </div>
      </div>
      {actions && <div style={{ display: 'flex', gap: 8 }}>{actions}</div>}
    </header>
  )
}
